import { customStyled, Box } from '@mafc/trolly';

export const PlasticBagQty = customStyled(Box)(({ theme }) => ({
  color: theme.colors.black,
  marginLeft: theme.space[1],
  marginRight: theme.space[1],
}));
